import { all, put, select, call } from 'redux-saga/effects'

import { actions, selectors } from '..'
import ApiSagas from '../api/sagas'
import { services } from '../../graphql'
import i18nInstance, { resources } from '../../i18n'

export default class ConfigurationSagas {
  static *init() {
    yield call(ConfigurationSagas.getWordings)
  }

  static *getWordings() {
    const rs = yield* ApiSagas.call(services.translation.queries.getTranslations)

    if (rs.data) {
      yield call(ConfigurationSagas.setWordings, rs.data)
    }
  }

  static *setWordings(wordings?: any) {
    const locale: string = yield select(selectors.configuration.defaultLocale)

    if (wordings) {
      yield put(
        actions.configuration.setWordings({
          wordings: {
            [locale]: { ...(resources as any)?.[locale]?.translation, ...wordings },
          },
        })
      )

      i18nInstance.addResourceBundle(
        locale,
        'translation',
        {
          ...(resources as any)?.[locale]?.translation,
          ...wordings,
        },
        true,
        true
      )
    }

    i18nInstance.changeLanguage(locale)
  }

  static *listeners() {
    yield all([])
  }
}
